import React from "react";
import { Link } from "react-router-dom";
import {
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  YoutubeFilled,
  PhoneOutlined,
  MailOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import zureSmileWhiteLogo from "../../assets/images/zuresmile-white.webp";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container mx-auto px-4 max-w-[1320px]">
        {/* Footer Top Logo */}
        <div className="mb-7">
          <a href="https://www.zuresmile.com/" title="ZureSmile Aligners">
            <img
              src={zureSmileWhiteLogo}
              alt="ZureSmile Aligners"
              width="210"
              height="52"
              loading="lazy"
              decoding="async"
              className="site-footerlogo"
            />
          </a>
        </div>

        {/* 4-Column Balanced Grid */}
        <div className="site-foot-row2">
          {/* Column 1: About & Certifications */}
          <div className="item item1">
            <span>How ZureSmile Aligners Work</span>
            <p>
              At ZureSmile, we believe that a smile is not just a reflection of good oral health, but also a powerful first impression that transforms your confidence through doctor-directed clear aligner treatments.
            </p>
            {/* Certifications Badges */}
            <div className="footer-cert-box mt-3">
              <div className="cert-badge">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="#58D2C2" className="flex-shrink-0"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" /></svg>
                <span className="cert-text">Certified Orthodontic Network</span>
              </div>
              <div className="cert-badge">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="#58D2C2" className="flex-shrink-0"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
                <span className="cert-text">100% Medical-Grade BPA-Free Aligners</span>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="item item2">
            <span>Quick Links</span>
            <ul>
              <li>
                <a href="https://www.zuresmile.com">Home</a>
              </li>
              <li>
                <a href="https://www.zuresmile.com/about-us/">About Us</a>
              </li>
              <li>
                <a href="https://www.zuresmile.com/benefits/">Benefits</a>
              </li>
              <li>
                <a href="https://www.zuresmile.com/blog/">Blog</a>
              </li>
              <li>
                <a href="https://www.zuresmile.com/contact-us/">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Column 3: Find Care */}
          <div className="item item3">
            <span>Find Care</span>
            <ul>
              <li>
                <Link to="/clinic">Find a Clinic</Link>
              </li>
              <li>
                <Link to="/doctor">Find Doctors</Link>
              </li>
              <li>
                <Link to="/search">Search by Location</Link>
              </li>
              <li>
                <a href="https://www.zuresmile.com/contact-us/">Request a Consultation</a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Support */}
          <div className="item item4">
            <span>Contact Support</span>
            <ul className="footer-contact-simple">
              <li>
                <a href="tel:+94771125112" className="contact-row-link">
                  <PhoneOutlined className="contact-icon" />
                  <span>+94 77 112 5112</span>
                </a>
              </li>
              <li>
                <a href="mailto:info@zuresmile.com" className="contact-row-link">
                  <MailOutlined className="contact-icon" />
                  <span>info@zuresmile.com</span>
                </a>
              </li>
              <li className="contact-row-item">
                <ClockCircleOutlined className="contact-icon" />
                <span>Mon – Sat: 9:00 AM – 7:00 PM</span>
              </li>
              <li className="contact-row-item">
                <EnvironmentOutlined className="contact-icon" style={{ marginTop: 2 }} />
                <span>
                  Island-wide Dental Centers,<br />
                  Sri Lanka
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr className="site-footer-hr" />

        {/* Copyright (Clean — No Terms/Privacy) */}
        <div className="site-copyrights">
          <p>© {new Date().getFullYear()} ZureSmile Aligners. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




